import { CURR_ENV } from '@/core/constants/appConfig/environment';

const gtagDataLayerNameBase = 'wtagl';
const gtagFunctionNameBase = 'wtagf';

export const getTagDataLayerName = (postFix: string) =>
  `${gtagDataLayerNameBase}_${CURR_ENV}_${postFix}`;

export const getGtagFuncName = (postFix: string) =>
  `${gtagFunctionNameBase}_${CURR_ENV}_${postFix}`;
